import currencyFormatter from "../../Helpers/currencyFormatter";
import creditArrow from '../../favicon/credit.png'
import debitArrow from '../../favicon/debit.png'
import { useContext, useEffect, useState } from "react";
import { Auth } from "../../Contexts/AuthContext";
import { APIRequest, ApiUrl } from "../../Helpers/ApiHelper";
import CustomLoader from "./Loader/CustomLoader";
import WithdrawRequestModal from "./WithdrawRequestModal";

const UserWalletInfo = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [showWithdrawModal, setShowWithdrawModal] = useState(false);
  const [walletTransaction, setWalletTransaction] = useState();
  const [totalWithdrawalAmount, setTotalWithdrawalAmount] = useState();
  const { auth, setAuth } = useContext(Auth);

  useEffect(() => {
    getWalletData()
  }, [])

  const getWalletData = () => {
    let config = {
      url: auth?.userRole === "BRAND" ? ApiUrl.brandWalletTransactions : ApiUrl.influencerWalletTransactions,
      method: 'GET',
      body: {},
    };
    APIRequest(
      config,
      res => {
        setWalletTransaction(res?.data);
        if (auth?.userRole === "INFLUENCER") {
          setTotalWithdrawalAmount(res?.total_withdrawal_amount);
          localStorage.setItem('user', JSON.stringify(res?.user));
          setAuth({
            ...auth,
            user: res.user,
          })
        }
        setIsLoading(false);
      },
      err => {
        setIsLoading(false);
      },
    );
  }
  return (

    <div className="wallet-wrapper">
      <CustomLoader visible={isLoading} />
      <div className="flex md:justify-start justify-center">
        <h4 className="font-museobb text-black ">My Wallet</h4>
      </div>
      <div className="flex py-2 items-center lg:flex-row flex-col gap-y-2 ">
        <span className="font-museob text-sm rounded-md border border-transparent bg-blue-500 px-5  text-center py-1 mr-0 md:mr-2  text-white shadow-sm focus:outline-none">
          Wallet Amount  : {currencyFormatter.format(auth?.user?.wallet_balance)}
        </span>
        {
          auth?.userRole === "INFLUENCER" && (
            <>
              <span className="font-museob  rounded-md border border-transparent bg-red-500 px-5 text-center py-1 text-sm  text-white shadow-sm focus:outline-none"
              >
                Total Withdrawed : {currencyFormatter.format(totalWithdrawalAmount)}
              </span>
              <div className=" px-4 py-2 text-right sm:px-6 flex justify-center items-center ">
                <span
                  onClick={setShowWithdrawModal}
                  className=" sm:w-[220px] w-[160px] h-[40px] sm:h-[55px] text-center cursor-pointer font-museob inline-flex items-center justify-center rounded-md border border-transparent bg-greenBtn  rounded-l-full rounded-r-full text-lg  text-white shadow-sm focus:outline-none
                  i  overflow-hidden transform  hover:scale-x-105 hover:scale-y-105 transition duration-300 ease-out"
                >
                  WITHDRAW
                </span>
              </div>
            </>
          )
        }

      </div>
      <div>
        <h4 className="py-2"> Transactions</h4>
        <div className="trasnaction-wrapper sbar">
          <div className="trasaction-list ">
            {walletTransaction?.map((transaction, i) => (
              <div key={`trasaction-${transaction?.id}`} className="transaction-item  flex flex-wrap ">
                <div className="flex items-center md:w-fit w-full justify-between md:justify-start md:gap-x-2 gap-x-0 ">
                  <div className="transaction-type">
                    <img width={18} src={transaction?.type === "deposit" ? creditArrow : debitArrow} alt={'transaction_image'} className="imgg" />
                  </div>

                  <div className="transaction-amount font-museobb  ">
                    <span className={`bg-${transaction?.type === "deposit" ? 'green' : 'red'}-500`}>
                      RM {currencyFormatter.format(transaction?.amount)}
                    </span>
                  </div>
                </div>

                  <div className="transaction-description ">
                    <div className="title">{transaction?.description}   <strong>{transaction?.for ? `for ${transaction?.for}` : ``} </strong></div>
                    <div className="caption mt-1">{transaction?.created_at}</div>
                  </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <WithdrawRequestModal showModal={showWithdrawModal} setShowModal={()=>setShowWithdrawModal(false)} /> 
    </div>

  );
};

export default UserWalletInfo;
